import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSharedModule } from '../input-shared.module';
import { InputDatepickerComponent } from './input-datepicker.component';
import {  } from 'primeng';
import { DatePicker } from 'primeng/datepicker';


@NgModule({
  declarations: [
    InputDatepickerComponent
  ],
  imports: [
    CommonModule,
    InputSharedModule,
    DatePicker,
  ],
  exports: [
    InputDatepickerComponent
  ]
})
export class InputDatepickerModule {
}
